module.exports = __webpack_public_path__ + "img/banner.e06cd55d.jpg";